import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";
import { useCountryArr } from "../../../hooks/useCountryArr";
import countries from "../../../utils/i18n-iso-countries-registered";

function CountriesSelect({ isoCountries, handleChange }) {
  const { i18n, t } = useTranslation(["adminNotificationConfig"]);
  const countryArr = useCountryArr();

  var customOverrideStrings = {
    allItemsAreSelected: t("countrySelect.allItemsAreSelected", {
      ns: "adminNotificationConfig",
    }),
    clearSearch: t("countrySelect.clearSearch", {
      ns: "adminNotificationConfig",
    }),
    clearSelected: t("countrySelect.clearSelected", {
      ns: "adminNotificationConfig",
    }),
    noOptions: t("countrySelect.noOptions", { ns: "adminNotificationConfig" }),
    search: t("countrySelect.search", { ns: "adminNotificationConfig" }),
    selectAll: t("countrySelect.selectAll", { ns: "adminNotificationConfig" }),
    selectAllFiltered: t("countrySelect.selectAllFiltered", {
      ns: "adminNotificationConfig",
    }),
    selectSomeItems: t("countrySelect.selectSomeItems", {
      ns: "adminNotificationConfig",
    }),
    create: t("countrySelect.create", { ns: "adminNotificationConfig" }),
  };

  function translateCountryList() {
    return isoCountries?.map((countryISO) => {
      let countryName;
      if (i18n.language === "de-DE") {
        countryName = countries.getName(countryISO, "de", {
          select: "official",
        });
      } else if (i18n.language === "es-ES") {
        countryName = countries.getName(countryISO, "es", {
          select: "official",
        });
      } else {
        countryName = countries.getName(countryISO, "en", {
          select: "official",
        });
      }

      return { label: countryName, value: countryISO };
    });
  }

  let arr = translateCountryList();
  const [selected, setSelected] = useState(arr);

  useEffect(() => {
    setSelected(translateCountryList());
  }, [i18n.language]);

  return (
    <MultiSelect
      overrideStrings={customOverrideStrings}
      id="countriesSelect"
      ClearSelectedIcon={null}
      options={countryArr}
      value={selected}
      onChange={async (e) => {
        await handleChange(
          e.map((e) => {
            return e.value;
          })
        ).then((payload) => {
          if (payload.success) {
            setSelected(e);
          }
        });
      }}
    />
  );
}

export default CountriesSelect;
